import format from 'date-fns/format';

import * as VideoType from '../player/videoSource/videoTypes';
import * as ADBPVideoType from '../tracking/ADBPVideoType';
import * as ADBPEventType from '../tracking/ADBPEventType';
import * as ADBPAdType from '../tracking/ADBPAdType';

import { inIframe } from '../utils/ASVPUtils';

import attempt from 'lodash/attempt';


const TRACKING_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export default class ADBP {
    constructor () {
        if (!window.trackMetrics) return false;
    }

    static getVideoData (videoSourceData, options = {}) {
        if (!videoSourceData) return {};

        const type = ADBP.getVideoType(videoSourceData.type);
        const duration = options.duration ? options.duration : videoSourceData.duration;

        const trackingDataObject = {
            adDuration: options.adDuration,
            adType: ADBP.getAdType(options.adType),
            buffering: options.buffering,
            paused: options.paused,
            contentId: videoSourceData.mediaId,
            franchise: videoSourceData.collectionTitle,
            headline: videoSourceData.title,
            id: videoSourceData.mediaId,
            lastAirDate: format(new Date(videoSourceData.launchDate * 1000), TRACKING_DATE_FORMAT),
            media: {
                duration,
            },
            mediaId: videoSourceData.mediaId,
            title: videoSourceData.title,
            tveMode: type === ADBPVideoType.STREAM ? 'linear' : 'C4',
            trt: duration,
            type,
        }

        const videoData = { video: {
            id: videoSourceData.id,
            title: ADBP.getCombinedVideoTitle(videoSourceData),
            type,
            offsite: inIframe(true),
            player_ad: undefined,
            segment_id: 1,
            duration,
            buffering: options.buffering,
            autoplayed: options.autoplayed,
            paused: options.paused
        }};

        return Object.assign({}, trackingDataObject, videoData);
    }

    static getUserInteractionData(sourceData, interactionType = 'user-interaction') {
        if (!sourceData) return {};

        return {
            interaction: interactionType,
            title: ADBP.getCombinedVideoTitle(sourceData)
        };
    }

    static getVideoType (type) {
        switch (type) {
            case VideoType.CLIP:
                return ADBPVideoType.CLIP;
            case VideoType.EPISODE:
                return ADBPVideoType.EPISODE;
            case VideoType.MARATHON:
                return ADBPVideoType.MARATHON;
            case VideoType.STREAM:
                return ADBPVideoType.STREAM;
            default:
                return ADBPVideoType.CLIP;
        }
    }

    static getAdType (type) {
        switch (type) {
            case tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL:
                return ADBPAdType.PREROLL;
            case tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL:
                return ADBPAdType.MIDROLL;
            case tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL:
                return ADBPAdType.POSTROLL;
        }
    }

    static getAuthTrackingType (type) {
        switch (type) {
            case ADBPEventType.VIDEO_PREROLL:
            case ADBPEventType.VIDEO_MIDROLL_START:
            case ADBPEventType.VIDEO_POSTROLL_START:
                return ADBPEventType.AD_START;
            case ADBPEventType.VIDEO_MIDROLL_COMPLETE:
            case ADBPEventType.VIDEO_POSTROLL_COMPLETE:
                return ADBPEventType.AD_COMPLETE;
            default:
                return type;
        }
    }

    static getCombinedVideoTitle (videoData) {
        return (videoData.type === VideoType.STREAM && !videoData.auth) ? 'streams:' + videoData.title : videoData.collectionTitle + ':' + videoData.title;
    }

    static trackUnauth (type, data) {
        if (!data) return;
        return attempt(() => window.trackMetrics({ type, data }));
    }

    static trackAuth (type, data) {
        if (!data) return;
        const authTrackingType = ADBP.getAuthTrackingType(type);
        return attempt(() => window.sendVideoEvent(authTrackingType, data));
    }

    static getClassName () {
        return 'analytics';
    }
};


// WEBPACK FOOTER //
// ./src/tracking/ADBP.js